import React, { ReactElement } from 'react';
import SkuStore from '@/stores/sku';
import NoticeStore from '@/stores/notice';
import cookieInfo from '@alife/bc-cookie-info';
import ExpressStore from '@/stores/express';
import DrawerStore from '@/stores/drawer';
import xman from '@/common/xman';

import doLog from '@/common/log';

import { isIframe, postFormData } from '@/common/iframe-post';

interface PropTypes {
  type: SkuTypes.TypeInfo;
  moq: number;
  productId: number;
  visitCountry: string;
  children: ReactElement<any, any>;
  price: PriceTypes.Root;
  showType?: string;
  i18n: DetailTypes.i18n;
}
// Continue to order
export default function Payment(props: PropTypes) {
  const SAMPLE_URL = `//biz.alibaba.com/contract/SampleOrder.htm?tracelog=from_detail_get_sample&pageId=${window.dmtrack_pageid}`;
  const ORDER_URL = `//biz.alibaba.com/contract/nowBuy.htm?pageId=${window.dmtrack_pageid}`;

  const { visitCountry, productId, type, moq, children, i18n, price, showType } = props;
  const {
    unit,
    unitEven,
    currencyRule: { rate, maximumFractionDigits },
  } = price;
  const noticeStore = NoticeStore((state) => state);
  const skuStore = SkuStore((state) => state);
  const expressStore = ExpressStore((state) => state);
  const { loading, setLoading } = DrawerStore((state) => state);
  const expressInfo = expressStore[type].express;

  const { quantity, isSoldOut } = skuStore[type];

  const selectedProductData = Object.values(skuStore[type].mapInfo)
    .filter((i) => i.quantity > 0)
    .map((i) => ({
      productId,
      skuId: i.skuId,
      dispatchLocation: expressStore.dispatchId,
      quantity: i.quantity,
      recommendStockCode: i.storeCode,
      inventoryId: i.id,
      freightCarrierCode: expressInfo?.methodCode,
    }));

  const handleSubmit = (e: { preventDefault: () => void; target: any }) => {
    e.preventDefault();
    const { target } = e;
    if (loading) return false;
    if (isSoldOut) return noticeStore.modify(i18n['detail_sku_soldout_tips']);
    // 拿样下单 moq
    if (type === 'sample' && quantity === 0) {
      return noticeStore.modify(i18n['detail_sku_moqneeded_tips'].replace('{0}', `1 ${unit}`));
    }
    // 商品下单 moq
    if (type === 'product' && quantity < moq) {
      return noticeStore.modify(
        i18n['detail_sku_moqneeded_tips'].replace('{0}', `${moq} ${moq > 1 ? unitEven : unit}`),
      );
    }

    // 价格一致性打点
    doLog(
      '/sc.details.startOrderPrice',
      JSON.stringify({
        selectedProductData,
        productPriceAfterDiscount: (document.querySelector('[data-price-product]') as HTMLElement)
          ?.dataset?.priceProduct,
        shippingPrice: expressInfo?.saveCost
          ? (document.querySelector('[data-price-express]') as HTMLElement)?.dataset
              ?.pricePromotionExpress
          : (document.querySelector('[data-price-express]') as HTMLElement)?.dataset?.priceExpress,
        totalPriceAfterDiscount: (document.querySelector('[data-price-total]') as HTMLElement)
          ?.dataset?.priceTotal,
        ...(expressInfo?.saveCost && {
          shippingPriceDiscount: (document.querySelector('[data-price-express]') as HTMLElement)
            ?.dataset?.priceExpress,
        }),
      }),
      'CLK',
    );

    // 支持iframe直接提交
    if (isIframe) {
      postFormData(target);
      return;
    }

    setLoading(true);

    // 提交表单
    xman(
      () => {
        setLoading(false);
        target.submit();
      },
      () => {
        setLoading(false);
      },
    );
  };

  return (
    <form onSubmit={handleSubmit} action={type === 'sample' ? SAMPLE_URL : ORDER_URL} method="post">
      <input type="hidden" name="dispatchLocation" value={expressStore.dispatchId} />
      <input type="hidden" name="clickId" value={3330} />
      <input type="hidden" name="pageId" value={window.dmtrack_pageid} />
      <input type="hidden" name="country" value={visitCountry} />
      {/* 下单页面的shippingCompany是物流code，"SEMI_MANAGED_PREMIUM@@PREMIUM" */}
      <input type="hidden" name="shippingCompany" value={expressInfo?.methodCode} />
      <input type="hidden" name="ftDetailId" value={expressInfo?.ftDetailId} />
      <input type="hidden" name="shippingMethod" value="express" />
      <input type="hidden" name="quantity" value={quantity} />
      <input type="hidden" name="productId" value={productId} />
      <input type="hidden" name="lang" value={cookieInfo.getBuyerLocale()} />
      <input type="hidden" name="data" value={JSON.stringify(selectedProductData)} />
      {children}
    </form>
  );
}
